import React from 'react';
import { SIDES } from './const';
import _ from 'lodash';
import { dbget, dbdel, dbset } from '../HOME/utils';

const MaxSteps = [15, 55, 85, 100];

export function blurText(text, blur, classes, style) {
  const color = 'rgb(155, 206, 239)';
  const shadow1 = `-1px -1px ${blur}px ${color}`;
  const shadow2 = `1px 1px ${blur}px ${color}`;

  return (
    <>
      <span className={classes} style={{ ...style, textShadow: shadow1 }}>
        {text}
      </span>
      <span className={classes} style={{ ...style, color: 'rgb(0, 55, 106)', textShadow: shadow2 }}>
        {text}
      </span>
    </>
  );
}

export function selectorClass(x, y) {
  return `tt-page simple-selector${x < y ? '' : ' simple-selector-landscape'}`;
}

export function canSurrender(props) {
  const board = props.board.current ? props.board.current : null;
  return board && !board.blocked;
}

const sideIndex = (cell, i) => {
  const turns = cell.turns % 4;
  i = (i - turns + 4) % 4;
  return i;
};

export const isAligned = (props, cells, cell) => {
  const { mode, size } = props;
  const { row, col, colors } = cell;

  const same = (r, c, i, j) => {
    const adjCell = cells[(r - 1) * size + c - 1];

    const i1 = sideIndex(cell, i);
    const j1 = sideIndex(adjCell, j);

    return colors[i1] === adjCell.colors[j1];
  };

  for (let i = 0; i < 4; i++) {
    if (mode === SIDES) {
      const r = i === 0 ? row - 1 : i === 2 ? row + 1 : row;

      if (r < 1 || r > size) {
        continue;
      }

      const c = i === 1 ? col + 1 : i === 3 ? col - 1 : col;

      if (c < 1 || c > size) {
        continue;
      }

      const j = i === 0 ? 2 : i === 1 ? 3 : i === 2 ? 0 : 1;

      if (!same(r, c, i, j)) {
        return false;
      }
    } else {
      let r, c, j;

      for (let k = 0; k < 3; k++) {
        switch (i) {
          case 0:
            r = k === 2 ? row : row - 1;
            c = k === 1 ? col : col - 1;
            j = k === 0 ? 2 : k === 1 ? 3 : 1;
            break;
          case 1:
            r = k === 2 ? row : row - 1;
            c = k === 0 ? col : col + 1;
            j = k === 0 ? 2 : k === 1 ? 3 : 0;
            break;
          case 2:
            r = k === 0 ? row : row + 1;
            c = k === 2 ? col : col + 1;
            j = k === 0 ? 3 : k === 1 ? 0 : 1;
            break;
          case 3:
            r = k === 0 ? row : row + 1;
            c = k === 1 ? col : col - 1;
            j = k === 0 ? 2 : k === 1 ? 0 : 1;
            break;
          default:
        }

        if (r < 1 || r > size || c < 1 || c > size) {
          continue;
        }

        if (!same(r, c, i, j)) {
          return false;
        }
      }
    }
  }

  return true;
};

const baseKey = props => {
  const { mode, size } = props;
  return `TT • ${mode.slice(0, 1)}${size} • `;
};

export function boardKey(props) {
  return `${baseKey(props)}BOARD`;
}

export function statsKey(props) {
  return `${baseKey(props)}STATS`;
}

export function getStats(props, resolve) {
  const key = statsKey(props);
  dbget(key, stats => {
    if (!stats) {
      stats = { plays: 0, aggScore: 0, bestScore: 0 };
    }

    resolve(stats);
  });
}

export function getMoreStats(stats, size, steps) {
  let { plays, aggScore, aveScore, bestScore } = stats || {};

  if (!aveScore) {
    aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);
  }

  const score = calcScore(steps || 0, size);
  const grade = _.round(((aveScore || 0) * Math.min(10, plays || 0)) / 10.0);
  return { plays, aveScore, bestScore, grade, score };
}

export function setStats(props, surrender) {
  dbdel(boardKey(props));

  let { steps, stats, size } = props;
  let { plays, aggScore, bestScore } = stats || {};

  plays += 1;
  steps = steps || 0;
  let score = 0;

  if (surrender) {
    steps = Math.max(steps, MaxSteps[size - 2]);
  } else {
    score = calcScore(steps, size);

    if (score === 1000) {
      score = 0;
    }
  }

  aggScore = (aggScore || 0) + score;

  bestScore = Math.max(score, bestScore || 0);

  const key = statsKey(props);
  stats = { plays, aggScore, bestScore };

  dbset(key, stats);
  props.updateStats(stats);
}

export const calcScore = (steps, size) => {
  const score = _.round(1000 * (1 - steps / MaxSteps[size - 2]));
  return Math.max(score, 10);
};

export const sizeName = size => {
  switch (size) {
    case 2:
      return 'XS';
    case 3:
      return 'S';
    case 4:
      return 'M';
    case 5:
      return 'L';
    default:
      break;
  }
};

export const colorString = cell => `${cell.colors[0]}${cell.colors[1]}${cell.colors[2]}${cell.colors[3]}`;
